(() => {
  const initialise = root => {
    if (root.dataset.cmReady) return;
    root.dataset.cmReady = 'true';
    const content = root.querySelector('[data-cm-article-content]');
    if (!content) return;
    const toc = root.querySelector('[data-cm-toc]');
    const list = root.querySelector('[data-cm-toc-list]');
    const headings = Array.from(content.querySelectorAll('h2')).filter(heading => heading.textContent.trim() && !/^(introduction|introduction to our faqs)$/i.test(heading.textContent.trim()));
    if (toc && list && headings.length > 2) {
      const links = [];
      headings.forEach((heading, index) => {
        if (!heading.id) heading.id = `cm-guide-section-${index + 1}`;
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent.trim().split(':')[0];
        link.addEventListener('click', () => { if (matchMedia('(max-width: 699px)').matches) toc.open = false; });
        item.appendChild(link);
        list.appendChild(item);
        links.push(link);
      });
      const syncAnchors = () => {
        content.querySelectorAll('.ruffruff-table-of-contents').forEach(legacy => legacy.remove());
        headings.forEach((heading, index) => { links[index].href = `#${heading.id}`; });
      };
      syncAnchors();
      new MutationObserver(syncAnchors).observe(content, { childList: true, attributes: true, attributeFilter: ['id'], subtree: true });
      toc.hidden = false;
      toc.open = matchMedia('(min-width: 700px)').matches;
    }
    content.querySelectorAll('table').forEach(table => {
      if (table.parentElement.classList.contains('cm-journal-table-wrap')) return;
      const wrap = document.createElement('div');
      wrap.className = 'cm-journal-table-wrap';
      wrap.tabIndex = 0;
      table.before(wrap);
      wrap.appendChild(table);
    });
    Array.from(content.querySelectorAll('p, .faq-question')).forEach(question => {
      if (!/^Q:\s*/i.test(question.textContent.trim())) return;
      let answer = question.nextElementSibling;
      while (answer && answer.tagName === 'P' && !answer.textContent.trim()) answer = answer.nextElementSibling;
      if (!answer || !(answer.tagName === 'P' || answer.classList.contains('faq-answer')) || !/^A:\s*/i.test(answer.textContent.trim())) return;
      const details = document.createElement('details');
      details.className = 'cm-journal-faq-item';
      const summary = document.createElement('summary');
      summary.textContent = question.textContent.trim().replace(/^Q:\s*/i, '');
      const answerWrap = document.createElement('div');
      const walker = document.createTreeWalker(answer, NodeFilter.SHOW_TEXT);
      const firstText = walker.nextNode();
      if (firstText) firstText.textContent = firstText.textContent.replace(/^\s*A:\s*/i, '');
      question.before(details);
      answerWrap.appendChild(answer);
      details.append(summary, answerWrap);
      question.remove();
    });
    const comments = root.querySelector('.cm-journal-comments');
    if (comments && (comments.querySelector('.errors') || location.hash === '#comments' || location.search.includes('comment'))) comments.open = true;
  };
  const run = () => document.querySelectorAll('[data-cm-journal]').forEach(initialise);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  else run();
  document.addEventListener('shopify:section:load', run);
})();

